import PropTypes from 'prop-types'
import React from 'react'

const PaymentMethodHeader = ({ description, children }) => (
  <div style={{ display: 'flex' }}>
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        flex: '1 1 100%',
        fontSize: '2.5rem',
      }}
    >
      {description}
    </div>
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-end',
        flex: '1 1 40%',
        flexWrap: 'wrap',
      }}
    >
      {children}
    </div>
  </div>
)

PaymentMethodHeader.propTypes = {
  description: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
}

PaymentMethodHeader.defaultProps = {
  children: null,
}

export default PaymentMethodHeader
